import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SdkCustomerModule } from '@xpo-ltl-2.0/sdk-customer';
import { xpoConfigManagerProvider } from '@xpo-ltl/config-manager';
import { DataApiService, NotificationService } from '@xpo-ltl/data-api';
import { XpoAppSwitcherPopoverModule } from '@xpo-ltl/ngx-ltl-core/app-switcher-popover';
import { XpoFooterModule } from '@xpo-ltl/ngx-ltl-core/footer';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import { XpoCardModule } from '@xpo-ltl/ngx-ltl-core/card';
import { XpoDialogModule } from '@xpo-ltl/ngx-ltl-core/dialog';
import { XpoPageNotFoundRoutingModule } from '@xpo-ltl/ngx-ltl-core/error-page';
import { XpoFeedbackModule } from '@xpo-ltl/ngx-ltl-core/feedback';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import { XpoShellModule } from '@xpo-ltl/ngx-ltl-core/shell';
import { XpoSnackBarModule } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { XpoAgGridModule } from '@xpo-ltl/ngx-ag-grid';
import { XpoLtlPopoverModule } from '@xpo-ltl/ngx-ltl-core/xpo-ltl-popover';
import { SdkUserPreferenceModule } from '@xpo-ltl/sdk-userpreference';
import { environment } from '../environments/environment';
import { NotificationComponent } from './notification/notification.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserRoleService } from './services/user-role/user-role.service';
import { NotificationMenuComponent } from './shared/components/notification-menu/notification-menu.component';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { ResultDialogComponent } from './obi/components/obi-incentive-detail-tabs/obi-incentive-shipments/result-dialog/result-dialog.component';
import { XpoErrorPagesModule } from '@xpo-ltl/ngx-ltl-core/error-pages';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { UserProfileComponent, xpoAuthConfigManagerConfiguration } from '@xpo-ltl/ngx-auth';

export const appAuthConfig = () => {
  return xpoConfigManagerProvider(
    xpoAuthConfigManagerConfiguration({
      firebaseOptions: environment.firebase,
      configFileUrl: './../assets/config.json',
    })
  );
};
@NgModule({
  declarations: [AppComponent, NotificationComponent, ResultDialogComponent, NotificationMenuComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    SharedModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatTableModule,
    MatAutocompleteModule,
    XpoShellModule,
    XpoFooterModule,
    XpoLtlPopoverModule,
    XpoAppSwitcherPopoverModule,
    XpoButtonModule,
    XpoCardModule,
    XpoDialogModule,
    XpoFeedbackModule,
    XpoSnackBarModule,
    XpoIconModule,
    XpoLtlPopoverModule,
    XpoAgGridModule,
    SdkUserPreferenceModule,
    SdkCustomerModule,
    MatMenuModule,
    MatIconModule,
    MatBadgeModule,
    MatDividerModule,
    MatListModule,
    MatProgressBarModule,
    XpoErrorPagesModule,
    MatTooltipModule,
    UserProfileComponent,
    AppRoutingModule,
    XpoPageNotFoundRoutingModule, // Keep Last
  ],
  providers: [appAuthConfig(), DatePipe, DataApiService, NotificationService, UserRoleService],
  bootstrap: [AppComponent],
})
export class AppModule {}
